module.exports = __webpack_public_path__ + "f6e9c23e8fe85e014e2e22be5ee3639f.png";